"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthService = exports.DatabaseAuthService = exports.CognitoAuthService = exports.mapUserInfo = void 0;
__exportStar(require("./auth-client"), exports);
__exportStar(require("./auth.types"), exports);
var auth_user_helper_1 = require("./auth-user.helper");
Object.defineProperty(exports, "mapUserInfo", { enumerable: true, get: function () { return auth_user_helper_1.mapUserInfo; } });
var cognito_service_1 = require("./cognito.service");
Object.defineProperty(exports, "CognitoAuthService", { enumerable: true, get: function () { return cognito_service_1.CognitoAuthService; } });
var database_auth_service_1 = require("./database-auth.service");
Object.defineProperty(exports, "DatabaseAuthService", { enumerable: true, get: function () { return database_auth_service_1.DatabaseAuthService; } });
var auth_service_1 = require("./auth.service");
Object.defineProperty(exports, "createAuthService", { enumerable: true, get: function () { return auth_service_1.createAuthService; } });
